export const ApiUrl = "https://cms.sultanpetdiocese.org/api";
